import { Button, ButtonTypes, Input, Modal } from "@clintonelec/react-storybook";
import { emailRegexObj } from "Data/Objects/Event";
import { type FormEvent, memo, type ReactNode, useState } from "react";

type EmailEntryModalProps = {
	children: ReactNode;
	emailEnabled: (email: string) => boolean;
	handleEmailEntryCallback: (email: string, oldEmail?: string) => void;
	oldEmail?: string;
};

function EmailEntryModal(props: EmailEntryModalProps) {
	const { children, handleEmailEntryCallback, emailEnabled, oldEmail } = props;
	const [ email, setEmail ] = useState<string>("");
	const [ visible, setVisible ] = useState(false);
	const isEnabled = emailRegexObj.test(email) && emailEnabled(email);
	const modalTitle = oldEmail ? "Edit Email" : "Add Email";

	const handleVisibilityChange = (newVisibility: boolean) => {
		setEmail("");
		setVisible(newVisibility);
	};

	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		event.stopPropagation();

		if (event.currentTarget?.checkValidity()) {
			handleEmailEntryCallback(email, oldEmail);
			setEmail("");
			setVisible(false);
		}
	};

	const handleEmailUpdate = (newEmail: string) => {
		setEmail(newEmail);
	};

	const modalContent = (
		<form
			className="event-notification-modal"
			noValidate
			onSubmit={ handleSubmit }
		>
			<Input
				onUpdate={ handleEmailUpdate }
				validator={ emailRegexObj }
				validityMessage="Incorrect E-Mail format."
				value={ email ?? oldEmail }
			/>
			<div className="modal-footer">
				<Button
					disabled={ !isEnabled }
					icon={ { name: "pencil" } }
					type={ ButtonTypes.TERTIARY }
				>
					Submit
				</Button>
			</div>
		</form>
	);

	return (
		<Modal
			modalContent={ modalContent }
			onVisibilityChange={ handleVisibilityChange }
			title={ modalTitle }
			visible={ visible }
		>
			{ children }
		</Modal>
	);
}

export default memo(EmailEntryModal);
